module.exports = __webpack_public_path__ + "static/media/0074_Small.22a62ad6.jpg";